// sizeConstants.ts
// (c) NCR Voyix Corporation 2025. All rights reserved.

export const DefaultDrawerWidth = 600
export const AppBarHeight = 64
